import React from 'react';
import ServicePageTemplate from './ServicePageTemplate';
import { digitalMarketingServicesConfig } from './servicePageConfigs';

const DigitalMarketingServices = () => (
  <ServicePageTemplate {...digitalMarketingServicesConfig} />
);

export default DigitalMarketingServices;
